export function sendRequest(url, callback, callbackError, callbackLoadStart, callbackLoadEnd)
{
    // ajax
    const xmlhttp = new XMLHttpRequest();

    // response očekáváme vždy json
    xmlhttp.responseType = 'json';

    xmlhttp.onloadstart = () => {
        if (typeof callbackLoadStart === 'function' && callbackLoadStart.call === Function.prototype.call) callbackLoadStart();
    };

    xmlhttp.onloadend = () => {
        if (typeof callbackLoadEnd === 'function' && callbackLoadEnd.call === Function.prototype.call) callbackLoadEnd();
    };

    xmlhttp.onload = () => {
        // process response
        if (xmlhttp.status === 200) {

            if (callback !== null)
            {
                callback(xmlhttp);
            }

        } else {
            callbackError();
        }
    };

    xmlhttp.onerror = () => {
        console.error('Request failed.');
    };

    xmlhttp.open("GET", url, true);

    // musíme nastavit hlavičky, jinak nám nebude fungovat snippet
    xmlhttp.setRequestHeader('Accept', '*/*');
    xmlhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    xmlhttp.send();
}